import { FORTA_BLACK, FORTA_ERROR } from '../../../../utils/colors';
import { CHECKBOX_BORDER_WIDTH, CHECKBOX_ICON_SIZE } from '../constants';

import type { SxProps, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

type BuildCheckboxSx = (error: boolean) => SystemStyleObject<Theme>;
type BuildCheckboxIconContainerSx = (color: string) => SystemStyleObject<Theme>;

type GetCheckboxColor = (error: boolean) => string;

export const getCheckboxColor: GetCheckboxColor = (error) => (error ? FORTA_ERROR : FORTA_BLACK);

export const buildCheckboxSx: BuildCheckboxSx = (error) => {
  const checkboxColor = getCheckboxColor(error);

  return {
    p: 0,
    marginInlineEnd: 1,
    color: checkboxColor,
    '& .MuiSvgIcon-root': {
      fontSize: CHECKBOX_ICON_SIZE,
    },
    '&.Mui-checked': {
      color: checkboxColor,
    },
    '&.MuiCheckbox-indeterminate': {
      color: checkboxColor,
    },
    '&.Mui-disabled': {
      color: FORTA_BLACK,
      // MUI sets `pointer-events: none` on disabled ButtonBase, which hides the cursor entirely.
      // Re-enable pointer events so the not-allowed cursor shows on hover; the input stays disabled.
      cursor: 'not-allowed',
      pointerEvents: 'auto',
    },
  };
};

export const buildCheckboxIconContainerSx: BuildCheckboxIconContainerSx = (color) => ({
  width: CHECKBOX_ICON_SIZE,
  height: CHECKBOX_ICON_SIZE,
  border: `${CHECKBOX_BORDER_WIDTH}px solid ${color}`,
  borderRadius: 1,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
});

type MergeSxProps = (base: SxProps<Theme>, sx: SxProps<Theme> | undefined) => SxProps<Theme>;

export const mergeSxProps: MergeSxProps = (base, sx) => {
  if (sx == null) {
    return base;
  }
  return [base, ...(Array.isArray(sx) ? sx : [sx])];
};
